import { apiClient } from '@/shared/api/client'
import type { ApiResource } from '@/shared/types/api'
import type { AuthPayload } from '@/shared/types/domain'

export async function exchangeImpersonationCode(code: string): Promise<AuthPayload> {
  const response = await apiClient.post<ApiResource<AuthPayload>>('/auth/impersonate/exchange', {
    code,
  })
  return response.data.data
}
